import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MainService } from 'src/app/portal/service/main.service';

@Injectable({
  providedIn: 'root'
})
export class AnganwadiService {


  httpUrl: string = ''
  constructor(private http: HttpClient, private main: MainService) {
    this.httpUrl = this.main.httpUrl + '/acms/anganwadi'
  }

  submitAnganwadi(obj: object): Observable<any> {
    return this.http.post(`${this.httpUrl}/submitAnganwadi`, obj)
  }

  processUploadedAnganwadiData(obj: object): Observable<any> {
    return this.http.post(`${this.httpUrl}/processUploadedAnganwadiData`, obj)
  }
  updateAnganwadi(obj: object): Observable<any> {
    return this.http.post(`${this.httpUrl}/updateAnganwadi`, obj)
  }
  deleteAnganwadi(obj: object): Observable<any> {
    return this.http.put(`${this.httpUrl}/deleteAnganwadi`, obj)
  }
  getAngawanwadiList(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/getAngawanwadiList` + obj)
  }
  getAngawanwadicount(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/getcount` + obj)
  }
  getAngawanwadiListById(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/angawanwadiById` + obj)
  }
  searchAnganwadi(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/searchAnganwadi` + obj)
  }


  exportreportl(obj: any): Observable<any> {
    return this.http.get(`${this.httpUrl}/getexcelreport` + obj, { responseType: 'blob' })
  }



  /*********************************************************** */

  getAllFinYear(obj: string): Observable<any> {
    return this.http.get(`${this.main.httpUrl}/accounts/journal/getAllFinYear` + obj)
  }
  getHierarchy(obj: object): Observable<any> {
    return this.http.post(`${this.main.httpUrl}/accounts/hierarchies/org_hier_xref_levels/getHierarchy`, obj)
  }
  //  getProjectHierarchy(obj: object): Observable<any> {
  //   return this.http.post(`${this.main.httpUrl}/accounts/hierarchies/project/getHierarchy` , obj)
  // }
  /*********************************************************** */



  /***********************************************************UPDATE SCREEN ************************************************** */
  getUpdatedanganwadicount(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/uCount` + obj)
  }


  getAnganwadiByCode(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/agByCode` + obj)
  }

  getUpdatedAngawanwadiList(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/updatedAngawanwadiList` + obj)
  }

  updatedAnganwadi(obj: object): Observable<any> {
    return this.http.post(`${this.httpUrl}/uAnganwadi`, obj)
  }
  getHierUpdatedAn(obj: object): Observable<any> {
    return this.http.get(`${this.httpUrl}/getHierOnUpdate` + JSON.stringify(obj))
  }

  /***********************************************************UPDATE SCREEN ************************************************** */

}
